import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, onMounted } from 'vue';
import { BFormGroup, BFormSelect } from 'bootstrap-vue';
import groupBy from 'lodash/groupBy';
import { useAxios } from 'composables/useAxios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'StandardSizeSelector',
    props: {
        value: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const axios = useAxios();
        const standardSizes = ref({});
        const sizeOptions = computed(() => [
            { label: 'A Sizes', options: standardSizes.value.a },
            { label: 'CM Sizes', options: standardSizes.value.cm },
            { label: 'Inch Sizes', options: standardSizes.value.inch },
            { label: 'Square Sizes', options: standardSizes.value.square }
        ]);
        function onChange(val) {
            emit('input', val);
        }
        onMounted(async () => {
            const { data } = await axios.get('sizes/all');
            standardSizes.value = groupBy(data.map(s => {
                const sizeType = s.type == 'inch' && s.size.length == s.size.width ? 'square' : s.type;
                return {
                    value: {
                        width: s.size.width,
                        length: s.size.length,
                        name: s.name,
                        type: sizeType
                    },
                    text: s.name,
                    type: sizeType
                };
            }), 'type');
        });
        return { __sfc: true, props, emit, axios, standardSizes, sizeOptions, onChange, ref, computed, onMounted, BFormGroup, BFormSelect, groupBy, useAxios };
    }
});
